import React from 'react';
import './App.css';
import Portfolio from './components/portfolioComponent';

function App() {
  return (
    <div>
      <Portfolio />
    </div>
  )
}

export default App;
